import React from "react";
import DemoMobilePreview from "components/demo/DemoMobilePreview";
import AppWalkthrough from "./AppWalkthrough";

const StageApps = ({
  operation,
  selectedRoute,
  onSelectRoute,
  role,
  onRoleChange,
  source,
  onNext,
  onBack,
}) => {
  return (
    <section className="start-stage">
      <header className="start-stage__header">
        <p className="start-kicker">One operation, three surfaces</p>
        <h2>Dispatcher, driver, and parent — the same routes</h2>
        <p>
          The walkthrough uses synthetic sample data. It is a demonstration of how the web dashboard and mobile apps
          stay connected. Real login codes, customer records, and live vehicle locations are not shown.
        </p>
      </header>

      {source !== "sample" && (
        <p className="start-note">
          Uploaded files stay as a roster preview here. Switch to the sample to walk a complete morning operation
          across dispatcher, driver, and parent views.
        </p>
      )}

      <AppWalkthrough
        operation={operation}
        selectedRoute={selectedRoute}
        onSelectRoute={onSelectRoute}
        role={role}
        onRoleChange={onRoleChange}
      />

      <div className="start-real-apps">
        <h3>The actual mobile apps</h3>
        <p>Screens from the live driver and parent applications for the same product.</p>
        <DemoMobilePreview compact className="start-dmp" />
      </div>

      <div className="start-stage__nav">
        <button type="button" className="start-btn start-btn--ghost" onClick={onBack}>
          Back
        </button>
        <button type="button" className="start-btn" onClick={onNext}>
          Continue with RouteBot
        </button>
      </div>
    </section>
  );
};

export default StageApps;
